import { createTheme } from '@mantine/core';

const errorStyles = {
  error: {
    color: 'var(--color-error)',
  },
};

export const theme = createTheme({
  breakpoints: {
    xs: '576px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
    xl: '1408px',
    xxl: '1536px',
  },
  colors: {
    brand: [
      'var(--color-green4)',
      'var(--color-green3)',
      'var(--color-green)',
      'var(--color-green2)',
      'var(--color-green-active)',
      'var(--color-green5)',
      'var(--color-green6)',
      'var(--color-green7)',
      'var(--color-green-hover)',
      'var(--color-green)',
    ],
    error: [
      'var(--color-error)',
      'var(--color-error2)',
      'var(--color-error2)',
      'var(--color-error2)',
      'var(--color-error2)',
      'var(--color-error2)',
      'var(--color-error2)',
      'var(--color-error2)',
      'var(--color-error2)',
      'var(--color-error2)',
    ],
    gray: [
      'var(--color-white)',
      'var(--color-gray)',
      'var(--color-offline)',
      'var(--color-offline2)',
      'var(--color-offline3)',
      'var(--color-gray2)',
      'var(--color-black-02)',
      'var(--color-black-04)',
      'var(--color-black)',
      'var(--color-black)',
    ],
    purple: [
      'var(--color-purple4)',
      'var(--color-purple3)',
      'var(--color-purple1)',
      'var(--color-purple2)',
      'var(--color-purple6)',
      'var(--color-purple5)',
      'var(--color-purple)',
      'var(--color-purple)',
      'var(--color-purple)',
      'var(--color-purple)',
    ],
  },
  components: {
    Button: {
      defaultProps: {
        color: 'brand',
      },
    },
    Container: {
      defaultProps: {
        c: 'var(--color-white-placeholder)',
      },
    },
    Divider: {
      defaultProps: {
        color: 'var(--color-white-placeholder)',
      },
    },
    Indicator: {
      defaultProps: {
        color: 'var(--color-green-active)',
      },
    },
    List: {
      defaultProps: {
        listStyleType: 'none',
        spacing: 'xs',
      },
    },
    Text: {
      defaultProps: {
        color: 'var(--color-white-placeholder)',
      },
    },
    TextInput: { styles: errorStyles },
    PasswordInput: { styles: errorStyles },
    Select: { styles: errorStyles },
    FileInput: { styles: errorStyles },
    Textarea: { styles: errorStyles },
    NumberInput: { styles: errorStyles },
    MultiSelect: { styles: errorStyles },
    Autocomplete: { styles: errorStyles },
    InputBase: { styles: errorStyles },
    DateTimePicker: { styles: errorStyles },
  },
  defaultRadius: 'md',
  fontFamily: 'EncodeSans_SemiExpanded, sans-serif',
  primaryColor: 'brand',
});
